import React from "react";

const FilterContexts = React.createContext();

export const FilterContextsProvider = ({children}) => {
    const [filters, setFilters] = React.useState({
        datas:{
            perpage: '',
            page: '',
            name: '',
            patientId: '',
            pdfType: 'OCT_G',
        },
        updateFunc: (updateTarget, value) => {
            setFilters(prevState => ({
                ...prevState,
                datas: {
                    ...prevState.datas,
                    [updateTarget]: value
                }
            }))
        }
    });

    return(
        <FilterContexts.Provider value={filters}>
            {children}
        </FilterContexts.Provider>
    );
};

export default FilterContexts;